// Main BentoBox exports
export { default as BentoCard } from "./components/BentoCard/BentoCard";
export { default as BentoCarouselContainer } from "./components/BentoCarouselContainer/BentoCarouselContainer";
export { default as CarouselHeader } from "./components/BentoCarouselContainer/CarouselHeader";
export { default as BentoHeader } from "./components/BentoHeader/BentoHeader";
export { default as BentoTab } from "./components/BentoTab/BentoTab";
export { default as SingleBentoContainer } from "./components/SingleBentoContainer/SingleBentoContainer";
export { default as TabsBentoContainer } from "./components/TabsBentoContainer/TabsBentoContainer";

// Footer components
export {
  InternetFooter,
  MobileFooter,
  PrepaidFooter,
} from "./components/TabsBentoContainer/FooterComponents";

// Export all types
export type {
  BentoCardButton,
  BentoCardProps,
  BentoCarouselContainerProps,
  BentoHeaderProps,
  BentoTabProps,
  TabData,
  TabListProps,
  TabsBentoContainerProps,
  TabsBentoData,
  TabType,
} from "./types";

// Main default export - the full TabsBentoContainer
export { default } from "./components/TabsBentoContainer/TabsBentoContainer";
